// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import CaretDown from "@awc/XDL/Icons/CaretDown";
import IconInputArrowDown from "@awc/XDL/Icons/IconInputArrowDown";
import { xBaseTheme } from "@awc/XDL/types";
import { color } from "@awc/XDL/Utilities";
import { IconWrapper } from "@insite/mobius/Icon";
import SelectPresentationPropsDefault from "@insite/mobius/Select/presentationProps";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...SelectPresentationPropsDefault,
        mergeCss: true,
        iconProps: {
            width: 11,
            height: 7,
            color: "common.ui5",
            src: IconInputArrowDown,
            css: css`
                &&& {
                    background-color: transparent;
                    padding-right: 12px;
                    width: auto;
                    top: 2px;
                }
            `,
        },
        css: css`
            cursor: pointer;
            &[aria-expanded="true"] ~ ${IconWrapper} {
                transform: rotate(180deg);
                padding-left: 12px;
            }
            &&&:focus-visible {
                outline: 1px solid ${color("common.ui9")};
            }
        `,
    },
} as xBaseTheme["select"];
